import React from "react";
import SelectField from "../../../components/SelectField";
import useFilterValue from "../Provider/hooks/useFilterValue";
import { FieldHaveErrorFC } from "./types";

const FieldHaveError: FieldHaveErrorFC = () => {
  const { value, update } = useFilterValue("haveError");
  const handlerChange = (haveError: string) => {
    update(haveError === "1" ? true : haveError === "0" ? false : undefined);
  };
  return (
    <SelectField
      size={"small"}
      onChange={handlerChange}
      items={[
        {
          label: "Да",
          value: "1",
        },
        {
          label: "Нет",
          value: "0",
        },
      ]}
      value={value === true ? "1" : value === false ? "0" : undefined}
      label={"Ошибки обновления"}
    />
  );
};

export default FieldHaveError;
